const menuButton = document.querySelector("[data-menu]");
const navLinks = document.querySelector(".nav-links");
const ageKey = "livyatanAgeApproved";
const cookieKey = "livyatanCookieConsent";

function createSiteNotice() {
  if (!localStorage.getItem(ageKey)) {
    const ageGate = document.createElement("div");
    ageGate.className = "age-gate";
    ageGate.setAttribute("role", "dialog");
    ageGate.setAttribute("aria-modal", "true");
    ageGate.innerHTML = `
      <div class="age-gate-box">
        <span class="eyebrow">יקב לוויתן</span>
        <h2>האתר מיועד לבני 18 ומעלה</h2>
        <p>הכניסה לאתר כוללת מידע ורכישה של משקאות אלכוהוליים. יש לאשר שהנך מעל גיל 18.</p>
        <div class="age-actions">
          <button class="btn" type="button" data-age-approve>אני מעל גיל 18</button>
          <a class="btn secondary" href="https://www.google.com">יציאה</a>
        </div>
      </div>
    `;
    document.body.appendChild(ageGate);
    document.body.classList.add("modal-open");

    ageGate.querySelector("[data-age-approve]").addEventListener("click", () => {
      localStorage.setItem(ageKey, "true");
      ageGate.remove();
      document.body.classList.remove("modal-open");
      showCookieBanner();
    });
  } else {
    showCookieBanner();
  }
}

function showCookieBanner() {
  if (localStorage.getItem(cookieKey) || document.querySelector(".cookie-banner")) return;

  const banner = document.createElement("div");
  banner.className = "cookie-banner";
  banner.innerHTML = `
    <div>
      <strong>שימוש בעוגיות</strong>
      <p>אנחנו משתמשים בעוגיות לשיפור חוויית הגלישה, מדידה והתאמת תוכן באתר.</p>
    </div>
    <div class="cookie-actions">
      <button class="btn" type="button" data-cookie-accept>מאשר/ת</button>
      <button class="btn secondary" type="button" data-cookie-decline>לא עכשיו</button>
    </div>
  `;
  document.body.appendChild(banner);

  banner.querySelector("[data-cookie-accept]").addEventListener("click", () => {
    localStorage.setItem(cookieKey, "accepted");
    banner.remove();
  });

  banner.querySelector("[data-cookie-decline]").addEventListener("click", () => {
    localStorage.setItem(cookieKey, "declined");
    banner.remove();
  });
}

createSiteNotice();

if (menuButton && navLinks) {
  menuButton.addEventListener("click", () => navLinks.classList.toggle("open"));
  navLinks.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => navLinks.classList.remove("open"));
  });
  window.addEventListener("scroll", () => navLinks.classList.remove("open"), { passive: true });
}

document.querySelectorAll("[data-zoom]").forEach((zoom) => {
  const image = zoom.querySelector("img");
  if (!image) return;

  zoom.addEventListener("mousemove", (event) => {
    const rect = zoom.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width) * 100;
    const y = ((event.clientY - rect.top) / rect.height) * 100;
    image.style.transformOrigin = `${x}% ${y}%`;
    zoom.classList.add("is-zooming");
  });

  zoom.addEventListener("mouseleave", () => {
    image.style.transformOrigin = "center";
    zoom.classList.remove("is-zooming");
  });
});

document.querySelectorAll("[data-countdown]").forEach((countdown) => {
  const target = new Date(countdown.dataset.countdown).getTime();
  const clock = countdown.querySelector("[data-countdown-clock]");
  const complete = countdown.querySelector("[data-countdown-complete]");
  const days = countdown.querySelector("[data-countdown-days]");
  const hours = countdown.querySelector("[data-countdown-hours]");
  const minutes = countdown.querySelector("[data-countdown-minutes]");
  const seconds = countdown.querySelector("[data-countdown-seconds]");

  if (!Number.isFinite(target) || !clock || !days || !hours || !minutes || !seconds) return;

  const pad = (value) => String(value).padStart(2, "0");
  const updateCountdown = () => {
    const remaining = target - Date.now();

    if (remaining <= 0) {
      clock.hidden = true;
      if (complete) complete.hidden = false;
      return false;
    }

    days.textContent = pad(Math.floor(remaining / 86400000));
    hours.textContent = pad(Math.floor((remaining % 86400000) / 3600000));
    minutes.textContent = pad(Math.floor((remaining % 3600000) / 60000));
    seconds.textContent = pad(Math.floor((remaining % 60000) / 1000));
    return true;
  };

  if (updateCountdown()) {
    const interval = window.setInterval(() => {
      if (!updateCountdown()) window.clearInterval(interval);
    }, 1000);
  }
});

const moneyFormatter = new Intl.NumberFormat("he-IL", {
  style: "currency",
  currency: "ILS",
  maximumFractionDigits: 0
});

const trackingCurrency = window.LivyatanTracking?.currency || "ILS";

function pushTrackingEvent(eventName, payload = {}) {
  window.dataLayer = window.dataLayer || [];
  if (payload.ecommerce) window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({ event: eventName, ...payload });
}

function cartItemToAnalyticsItem(item, quantityOverride) {
  const quantity = Number(quantityOverride ?? item.quantity ?? 1);
  const cents = Number(item.final_price ?? item.price ?? item.original_price ?? 0);
  return {
    item_id: String(item.product_id || item.id || item.variant_id || ""),
    item_name: item.product_title || item.title || "",
    item_category: item.product_type || "יין",
    item_variant: item.variant_title || item.variant_options?.join(" / ") || "",
    price: cents / 100,
    quantity
  };
}

function pushCartAdd(item) {
  const analyticsItem = cartItemToAnalyticsItem(item);
  const value = analyticsItem.price * analyticsItem.quantity;
  pushTrackingEvent("add_to_cart", {
    product_id: analyticsItem.item_id,
    product_name: analyticsItem.item_name,
    product_category: analyticsItem.item_category,
    variant: analyticsItem.item_variant,
    quantity: analyticsItem.quantity,
    currency: trackingCurrency,
    price: analyticsItem.price,
    ecommerce: {
      currency: trackingCurrency,
      value,
      items: [analyticsItem]
    }
  });
  pushTrackingEvent("AddToCart", {
    content_type: "product",
    content_ids: [analyticsItem.item_id],
    content_name: analyticsItem.item_name,
    value,
    currency: trackingCurrency,
    quantity: analyticsItem.quantity
  });
}

function pushCartRemove(item, quantityRemoved) {
  const analyticsItem = cartItemToAnalyticsItem(item, quantityRemoved);
  pushTrackingEvent("remove_from_cart", {
    product_id: analyticsItem.item_id,
    product_name: analyticsItem.item_name,
    product_category: analyticsItem.item_category,
    variant: analyticsItem.item_variant,
    quantity: analyticsItem.quantity,
    currency: trackingCurrency,
    price: analyticsItem.price,
    ecommerce: {
      currency: trackingCurrency,
      value: analyticsItem.price * analyticsItem.quantity,
      items: [analyticsItem]
    }
  });
}

function pushCheckoutStart(cart) {
  const items = (cart.items || []).map((item) => cartItemToAnalyticsItem(item));
  pushTrackingEvent("begin_checkout", {
    currency: trackingCurrency,
    transaction_value: (Number(cart.total_price) || 0) / 100,
    total_bottles: Number(cart.item_count) || 0,
    ecommerce: {
      currency: trackingCurrency,
      value: (Number(cart.total_price) || 0) / 100,
      items
    }
  });
  pushTrackingEvent("InitiateCheckout", {
    content_type: "product",
    value: (Number(cart.total_price) || 0) / 100,
    currency: trackingCurrency,
    contents: items.map((item) => ({ id: item.item_id, quantity: item.quantity }))
  });
}

function formatCartMoney(cents) {
  return moneyFormatter.format((Number(cents) || 0) / 100);
}

function getQuantityInput(scope) {
  return scope ? scope.querySelector("[data-quantity-input]") : null;
}

function normalizeQuantity(value, minimum = 1) {
  const quantity = Number.parseInt(value, 10);
  if (!Number.isFinite(quantity)) return minimum;
  return Math.max(minimum, quantity);
}

function setCartFeedback(form, message) {
  const feedback = form.querySelector("[data-cart-feedback]");
  if (!feedback) return;
  feedback.textContent = message;
  window.setTimeout(() => {
    if (feedback.textContent === message) feedback.textContent = "";
  }, 2600);
}

function updateCartBadges(cart) {
  document.querySelectorAll("[data-cart-count], [data-cart-item-count]").forEach((badge) => {
    badge.textContent = cart.item_count;
  });

  document.querySelectorAll("[data-cart-subtotal]").forEach((subtotal) => {
    subtotal.textContent = formatCartMoney(cart.items_subtotal_price);
  });

  document.querySelectorAll("[data-cart-total]").forEach((total) => {
    total.textContent = formatCartMoney(cart.total_price);
  });

  document.querySelectorAll("[data-cart-benefit]").forEach((benefit) => {
    const totalItems = Number(cart.item_count) || 0;
    if (totalItems < 6) {
      benefit.textContent = `נותרו עוד ${6 - totalItems} בק׳ להזמנה אישית לאירוע השקה`;
    } else if (totalItems < 12) {
      benefit.textContent = `זכאי.ת להזמנה אישית. נותרו עוד ${12 - totalItems} בק׳ להזמנה זוגית`;
    } else {
      benefit.textContent = "זכאי.ת להזמנה זוגית";
    }
  });
}

function renderCartLine(item) {
  const image = item.image ? `<img src="${item.image}" alt="">` : "";
  const variant = item.variant_title && item.variant_title !== "Default Title" ? `<p>${item.variant_title}</p>` : "";

  return `
    <div class="cart-line" data-cart-line data-cart-key="${item.key}">
      ${image}
      <div>
        <h3>${item.product_title}</h3>
        ${variant}
        <div class="qty-control" aria-label="כמות עבור ${item.product_title}">
          <button type="button" data-qty-adjust="-1" data-cart-key="${item.key}" aria-label="הפחתת כמות">-</button>
          <input type="number" value="${item.quantity}" min="0" inputmode="numeric" data-quantity-input data-cart-key="${item.key}" aria-label="כמות">
          <button type="button" data-qty-adjust="1" data-cart-key="${item.key}" aria-label="הוספת יחידה">+</button>
        </div>
      </div>
      <strong data-line-price>${formatCartMoney(item.final_line_price)}</strong>
    </div>
  `;
}

function syncCartLines(cart) {
  const cartPanel = document.querySelector(".cart-panel");
  if (!cartPanel) return;

  cart.items.forEach((item) => {
    let line = Array.from(document.querySelectorAll("[data-cart-line]")).find((cartLine) => cartLine.dataset.cartKey === item.key);

    if (!line) {
      const heading = cartPanel.querySelector("h2");
      if (heading) heading.insertAdjacentHTML("afterend", renderCartLine(item));
      line = Array.from(document.querySelectorAll("[data-cart-line]")).find((cartLine) => cartLine.dataset.cartKey === item.key);
    }

    if (!line) return;
    const input = line.querySelector("[data-quantity-input]");
    const price = line.querySelector("[data-line-price]");
    if (input) {
      input.value = item.quantity;
      input.defaultValue = item.quantity;
    }
    if (price) price.textContent = formatCartMoney(item.final_line_price);
  });

  document.querySelectorAll("[data-cart-line]").forEach((line) => {
    const key = line.dataset.cartKey;
    if (!cart.items.some((item) => item.key === key)) line.remove();
  });
}

async function getCart() {
  const response = await fetch("/cart.js", { headers: { Accept: "application/json" } });
  if (!response.ok) throw new Error("Cart request failed");
  return response.json();
}

async function changeCartItem(key, quantity) {
  const response = await fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify({ id: key, quantity })
  });

  if (!response.ok) throw new Error("Cart update failed");
  return response.json();
}

async function addToCart(form) {
  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: { Accept: "application/json" },
    body: new FormData(form)
  });

  if (!response.ok) throw new Error("Cart add failed");
  return response.json();
}

document.addEventListener("click", async (event) => {
  const button = event.target.closest("[data-qty-adjust]");
  if (!button) return;

  event.preventDefault();
  const control = button.closest(".qty-control");
  const input = getQuantityInput(control);
  if (!input) return;

  const isCartQuantity = Boolean(button.dataset.cartKey);
  const minimum = isCartQuantity ? 0 : 1;
  const previousQuantity = normalizeQuantity(input.value, minimum);
  const nextQuantity = previousQuantity + Number(button.dataset.qtyAdjust || 0);
  input.value = Math.max(minimum, nextQuantity);

  if (!isCartQuantity) return;

  button.disabled = true;
  try {
    let removedItem = null;
    const removedQuantity = Math.max(0, previousQuantity - Number(input.value));
    if (removedQuantity > 0) {
      const previousCart = await getCart();
      removedItem = previousCart.items.find((item) => item.key === button.dataset.cartKey);
    }
    const cart = await changeCartItem(button.dataset.cartKey, Number(input.value));
    if (removedItem && removedQuantity > 0) pushCartRemove(removedItem, removedQuantity);
    updateCartBadges(cart);
    syncCartLines(cart);
  } catch (error) {
    window.location.href = "/cart";
  } finally {
    button.disabled = false;
  }
});

document.addEventListener("change", async (event) => {
  const input = event.target.closest("[data-quantity-input][data-cart-key]");
  if (!input) return;

  input.value = normalizeQuantity(input.value, 0);
  try {
    const previousQuantity = Number(input.defaultValue || input.getAttribute("value") || 0);
    let removedItem = null;
    const removedQuantity = Math.max(0, previousQuantity - Number(input.value));
    if (removedQuantity > 0) {
      const previousCart = await getCart();
      removedItem = previousCart.items.find((item) => item.key === input.dataset.cartKey);
    }
    const cart = await changeCartItem(input.dataset.cartKey, Number(input.value));
    if (removedItem && removedQuantity > 0) pushCartRemove(removedItem, removedQuantity);
    input.defaultValue = input.value;
    updateCartBadges(cart);
    syncCartLines(cart);
  } catch (error) {
    window.location.href = "/cart";
  }
});

document.querySelectorAll(".ajax-cart-form").forEach((form) => {
  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    const submit = form.querySelector("button[type='submit']");
    if (submit) submit.disabled = true;

    try {
      const addedItem = await addToCart(form);
      pushCartAdd(addedItem);
      const cart = await getCart();
      updateCartBadges(cart);
      syncCartLines(cart);
      setCartFeedback(form, "נוסף לסל");
      const upsellLine = form.closest(".cart-upsell .upsell-line");
      if (upsellLine) upsellLine.remove();
    } catch (error) {
      form.submit();
    } finally {
      if (submit) submit.disabled = false;
    }
  });
});

document.querySelectorAll("form[action*='/cart'][method='post']").forEach((form) => {
  form.addEventListener("submit", async (event) => {
    if (!event.submitter || event.submitter.name !== "checkout") return;
    event.preventDefault();
    try {
      const cart = await getCart();
      pushCheckoutStart(cart);
    } catch (error) {
      pushTrackingEvent("begin_checkout", { currency: trackingCurrency });
      pushTrackingEvent("InitiateCheckout", { currency: trackingCurrency });
    }
    if (!form.querySelector("input[name='checkout']")) {
      const checkoutInput = document.createElement("input");
      checkoutInput.type = "hidden";
      checkoutInput.name = "checkout";
      checkoutInput.value = "checkout";
      form.appendChild(checkoutInput);
    }
    form.submit();
  });
});

document.querySelectorAll("form[action*='/contact']").forEach((form) => {
  form.addEventListener("submit", () => {
    const isNewsletter = form.querySelector("input[name='contact[tags]'][value*='newsletter']");
    const formName = isNewsletter ? "newsletter_signup" : "contact_form";
    const leadSource = isNewsletter ? "newsletter" : "contact";
    pushTrackingEvent("lead", {
      lead_source: leadSource,
      form_name: formName
    });
    pushTrackingEvent("Lead", {
      lead_source: leadSource,
      form_name: formName
    });
  });
});

document.querySelectorAll("a[href*='/pages/launch'], a[href*='/pages/subscription']").forEach((link) => {
  link.addEventListener("click", () => {
    pushTrackingEvent("lead", {
      lead_source: "wine_club",
      form_name: "wine_club_signup"
    });
    pushTrackingEvent("Lead", {
      lead_source: "wine_club",
      form_name: "wine_club_signup"
    });
  });
});

document.querySelectorAll("[data-select-item]").forEach((link) => {
  link.addEventListener("click", () => {
    const card = link.closest("[data-tracking-product]");
    if (!card) return;
    const item = {
      item_id: card.dataset.productId || "",
      item_name: card.dataset.productTitle || "",
      item_category: card.dataset.productCategory || "יין",
      item_variant: card.dataset.productVariant || "",
      price: Number(card.dataset.productPrice || 0),
      quantity: 1
    };
    pushTrackingEvent("select_item", {
      product_id: item.item_id,
      product_name: item.item_name,
      product_category: item.item_category,
      variant: item.item_variant,
      currency: trackingCurrency,
      price: item.price,
      ecommerce: {
        item_list_name: card.dataset.productList || "",
        items: [item]
      }
    });
  });
});

document.querySelectorAll("[data-launch-page]").forEach((launchPage) => {
  const products = Array.from(launchPage.querySelectorAll("[data-launch-product]"));
  const checkoutButton = launchPage.querySelector("[data-launch-checkout]");
  const totalItemsNode = launchPage.querySelector("[data-launch-total-items]");
  const totalPriceNode = launchPage.querySelector("[data-launch-total-price]");
  const totalSavingNode = launchPage.querySelector("[data-launch-total-saving]");
  const benefitNode = launchPage.querySelector("[data-launch-benefit]");
  const upsellNode = launchPage.querySelector("[data-launch-upsell]");
  const quantities = new Map();

  const getLaunchItems = () => products.map((product) => {
    const variantId = product.dataset.variantId;
    const quantity = quantities.get(variantId) || 0;
    const price = Number(product.dataset.price || 0);
    const comparePrice = Number(product.dataset.comparePrice || price);
    return {
      product,
      variantId,
      quantity,
      price,
      comparePrice,
      title: product.dataset.productTitle || "",
      sku: product.dataset.sku || ""
    };
  });

  const getSelectedItems = () => getLaunchItems().filter((item) => item.quantity > 0);

  const getAnalyticsItems = () => getSelectedItems().map((item) => ({
    item_id: item.sku || item.variantId,
    item_name: item.title,
    item_category: "יין",
    price: item.price / 100,
    quantity: item.quantity
  }));

  const trackMeta = (eventName, payload = {}) => {
    pushTrackingEvent(eventName, payload);
  };

  const trackGoogle = (eventName, payload = {}) => {
    const trackingPayload = { ...payload };
    if (trackingPayload.items) {
      trackingPayload.ecommerce = {
        currency: trackingPayload.currency || trackingCurrency,
        value: trackingPayload.value,
        items: trackingPayload.items
      };
    }
    pushTrackingEvent(eventName, trackingPayload);
  };

  const updateLaunchSummary = () => {
    const items = getLaunchItems();
    const totalItems = items.reduce((sum, item) => sum + item.quantity, 0);
    const totalPrice = items.reduce((sum, item) => sum + item.price * item.quantity, 0);
    const totalCompare = items.reduce((sum, item) => sum + item.comparePrice * item.quantity, 0);
    const totalSaving = Math.max(0, totalCompare - totalPrice);

    products.forEach((product) => {
      const variantId = product.dataset.variantId;
      const qty = quantities.get(variantId) || 0;
      const qtyNode = product.querySelector("[data-launch-product-qty]");
      if (qtyNode) qtyNode.textContent = qty;
    });

    if (totalItemsNode) totalItemsNode.textContent = totalItems;
    if (totalPriceNode) totalPriceNode.textContent = formatCartMoney(totalPrice);
    if (totalSavingNode) totalSavingNode.textContent = formatCartMoney(totalSaving);
    if (checkoutButton) checkoutButton.disabled = totalItems === 0;

    if (benefitNode) {
      if (totalItems < 6) {
        benefitNode.textContent = `נותרו עוד ${6 - totalItems} בק׳ להזמנה לאירוע השקה`;
      } else if (totalItems < 12) {
        benefitNode.textContent = "זכאי.ת להזמנה אישית";
      } else {
        benefitNode.textContent = "זכאי.ת להזמנה זוגית";
      }
    }

    if (upsellNode) {
      if (totalItems >= 6 && totalItems <= 11) {
        upsellNode.hidden = false;
        upsellNode.textContent = `חסרים לך ${12 - totalItems} בקבוקים להזמנה זוגית`;
      } else {
        upsellNode.hidden = true;
        upsellNode.textContent = "";
      }
    }
  };

  products.forEach((product) => {
    const variantId = product.dataset.variantId;
    quantities.set(variantId, 0);

    product.querySelector("[data-launch-add]")?.addEventListener("click", () => {
      quantities.set(variantId, (quantities.get(variantId) || 0) + 1);
      updateLaunchSummary();
    });

    product.querySelectorAll("[data-launch-qty]").forEach((button) => {
      button.addEventListener("click", () => {
        const next = Math.max(0, (quantities.get(variantId) || 0) + Number(button.dataset.launchQty || 0));
        quantities.set(variantId, next);
        updateLaunchSummary();
      });
    });
  });

  const viewItems = products.map((product) => ({
    item_id: product.dataset.sku || product.dataset.variantId,
    item_name: product.dataset.productTitle || "",
    item_category: "יין",
    price: Number(product.dataset.price || 0) / 100
  }));

  trackMeta("ViewContent", {
    content_name: "לוויתן | מכירה מוקדמת והשקת סדרת היינות",
    content_type: "product_group"
  });
  trackGoogle("view_item", {
    currency: trackingCurrency,
    items: viewItems
  });

  checkoutButton?.addEventListener("click", async () => {
    const selectedItems = getSelectedItems();
    if (!selectedItems.length) return;

    checkoutButton.disabled = true;
    checkoutButton.textContent = "מעביר לתשלום...";

    const value = selectedItems.reduce((sum, item) => sum + item.price * item.quantity, 0) / 100;
    const analyticsItems = getAnalyticsItems();

    trackMeta("AddToCart", {
      content_type: "product",
      currency: trackingCurrency,
      value
    });
    trackGoogle("add_to_cart", {
      currency: trackingCurrency,
      value,
      items: analyticsItems
    });

    trackMeta("InitiateCheckout", {
      content_type: "product",
      currency: trackingCurrency,
      value
    });
    trackGoogle("begin_checkout", {
      currency: trackingCurrency,
      value,
      total_bottles: selectedItems.reduce((sum, item) => sum + item.quantity, 0),
      items: analyticsItems
    });

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          items: selectedItems.map((item) => ({
            id: Number(item.variantId),
            quantity: item.quantity
          }))
        })
      });

      if (!response.ok) throw new Error("Launch checkout failed");
      window.location.href = "/checkout";
    } catch (error) {
      checkoutButton.disabled = false;
      checkoutButton.textContent = "המשך לתשלום";
      window.location.href = "/cart";
    }
  });

  updateLaunchSummary();
});
